import React, { useEffect, FC } from "react";
import { Modal, ModalBody, Form, Row, Alert } from "reactstrap";
import { Icon, Button, RSelect } from "../../../components/Component";
import { useForm } from "react-hook-form";
import { Col } from "reactstrap";
const EditModal: FC<any> = ({
  modal,
  closeModal,
  onSubmit,
  formData,
  setFormData,
  filterStatus,
  alertInfo,
}) => {
  useEffect(() => {
    reset(formData);
  }, [formData]);
  const {
    reset,
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  return (
    <Modal
      isOpen={modal}
      toggle={() => closeModal()}
      className="modal-dialog-centered"
      size="lg"
      backdrop="static"
    >
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            closeModal();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">Update Department</h5>
          {alertInfo.message && (
            <div className="mb-3 mt-1">
              <Alert
                color={alertInfo.type === "error" ? "danger" : "success"}
                className="alert-icon"
              >
                <strong>{alertInfo.message}</strong>
                <Icon
                  name={
                    alertInfo.type === "error" ? "alert-circle" : "check-circle"
                  }
                />
                {alertInfo.errors.length > 0 ? (
                  <ul>
                    {alertInfo.errors.map((err: any, index: any) => (
                      <li key={index}>{err}</li>
                    ))}
                  </ul>
                ) : (
                  ""
                )}
              </Alert>
            </div>
          )}
          <div className="mt-4">
            <Form className="row gy-4" onSubmit={handleSubmit(onSubmit)}>
              <Col md="4">
                <div className="form-group">
                  <label className="form-label">
                  Department ID<span className="mandatory">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    {...register("referenceID", {
                      required: "This field is required",
                    })}
                    value={formData.referenceID}
                    onChange={(e) =>
                      setFormData({ ...formData, referenceID: e.target.value })
                    }
                    placeholder="Enter Department ID"
                  />
                  {errors.referenceID &&
                    typeof errors.referenceID.message === "string" && (
                      <span className="invalid">
                        {errors.referenceID.message}
                      </span>
                    )}
                </div>
              </Col>
              <Col md="4">
                <div className="form-group">
                  <label className="form-label">
                    Department Name<span className="mandatory">*</span>
                  </label>
                  <input
                    className="form-control"
                    type="text"
                    {...register("deptName", {
                      required: "This field is required",
                    })}
                    value={formData.deptName}
                    onChange={(e) =>
                      setFormData({ ...formData, deptName: e.target.value })
                    }
                    placeholder="Enter Dept Name"
                  />
                  {errors.deptName &&
                    typeof errors.deptName.message === "string" && (
                      <span className="invalid">{errors.deptName.message}</span>
                    )}
                </div>
              </Col>
              <Col md="4">
                <div className="form-group">
                  <label className="form-label">Team Count</label>
                  <input
                    className="form-control"
                    type="number"
                    {...register("teamCount", {
                      pattern: {
                        value: /^[1-9]+$/, // Only digits
                        message: "Only digits are allowed",
                      },
                    })}
                    value={formData.teamCount}
                    onChange={(e) =>
                      setFormData({ ...formData, teamCount: e.target.value })
                    }
                    placeholder="Team Count"
                  />
                  {/* {errors.teamCount && <span className="invalid">{errors.teamCount.message}</span>} */}
                </div>
              </Col>
              <Col md="12">
                <div className="form-group">
                  <label className="form-label">
                    Description<span className="mandatory">*</span>
                  </label>
                  <textarea
                    className="form-control form-control-sm"
                    id="fv-message"
                    {...register("description", {
                      required: true,
                    })}
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    placeholder="Write your description"
                  />
                  {errors.description &&
                    typeof errors.description.message === "string" && (
                      <span className="invalid">
                        {errors.description.message}
                      </span>
                    )}
                </div>
              </Col>
              <Row className="mt-4">
                <Col
                  size="12"
                  sm={undefined}
                  lg={undefined}
                  md={undefined}
                  xxl={undefined}
                  className={undefined}
                >
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                    <li>
                      <Button
                        className="btn btn-primary btn-md"
                        type="submit"
                        color="primary"
                      >
                        <span>Update</span>
                      </Button>
                    </li>
                    <li>
                      <a
                        href="#cancel"
                        onClick={(ev) => {
                          ev.preventDefault();
                          closeModal();
                        }}
                        className="link link-light"
                      >
                        Cancel
                      </a>
                    </li>
                  </ul>
                </Col>
              </Row>
            </Form>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};
export default EditModal;
